export default __webpack_public_path__ + "static/media/edit-pencil.8729b0c2.svg";